// extracted by mini-css-extract-plugin
module.exports = {"main":"AvailabilityResult_main__2Lymd","filters":"AvailabilityResult_filters__32lXn","hotels":"AvailabilityResult_hotels__3NRGR","hotel":"AvailabilityResult_hotel__kZTGq"};